import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { style: {"margin":"15px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("report.performancesNotes")), 1)
    ]),
    _createVNode(_component_apexchart, {
      class: "statistics-widget-3-chart card-rounded-bottom",
      options: _ctx.options,
      series: _ctx.series,
      height: 300,
      type: "line"
    }, null, 8, ["options", "series"])
  ]))
}